import { render, staticRenderFns } from "./component-outer-casing.vue?vue&type=template&id=80484df2&scoped=true&"
import script from "./component-outer-casing.vue?vue&type=script&lang=js&"
export * from "./component-outer-casing.vue?vue&type=script&lang=js&"
import style0 from "./component-outer-casing.vue?vue&type=style&index=0&id=80484df2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80484df2",
  null
  
)

export default component.exports